import React from "react";
import roconLogo from "../../GlobalAssets/PNG/RoconLogo.png";
import styles from "./OrgPageLoadingStyle.module.scss";
import { Box } from "@mui/material";

const OrgOverviewPageLoading = () => {
  const appConfig = JSON.parse(localStorage.getItem("appConfig") || "{}");
  const appLogo = appConfig.icon;

  return (
    <div className={styles.loadingContainer}>
      <Box className={styles.backGround}>
        <img src={appLogo} className={styles.loadingImage} alt="Loading" />
        <Box className={styles.coinSpinner} />
      </Box>
    </div>
  );
};

export default OrgOverviewPageLoading;
